import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment';

import '../styles/rrule.module.scss';
import { Row, Col } from 'react-flexbox-grid';
import { Frequency } from 'rrule';
// import { calendarFunctions } from '../../../helpers/calendar-functions';
import Dropdown from '../../../components/Dropdown';
import Datepicker from '../../../components/Datepicker';

const uuidv4 = require('uuid/v4')

class RRuleInput extends Component {

    constructor (props) {
        super(props);
        
        this.state = {
            rRuleObject: {
                dtstart: null,
                freq: null,
                interval: null,
                wkst: 0,
                until: null
            },
            frequency: '',
            untilOption: '',
            rUntilDate: this.untilOptions[0].value,
            customFrequency: 'day',
            customEnd: 'never',
            valueUntilDate: {},
            recurrenceDefaultValue: this.options[0],
            untilDefaultValue: this.untilOptions[0],
            untilOptions: this.untilOptions,
            showCustom: false,
            showWeekDays: false,
            showCustomEndDate: false,
            showCustomEndExecutions: false,
            hideUntil: true,
            hideCustom: true,
            untilDate: moment().toISOString(),
            minUntilDate: moment().toISOString(),
            untilDateKey: uuidv4(),
            dropdownKey: uuidv4()
        }
    }

    options = [
        {value: 'none', label: 'None'},
        {value: 'daily', label: 'Everyday'},
        {value: 'weekly', label: 'Every Week'},
        {value: 'weekly2', label: 'Every 2 Weeks'},
        {value: 'monthly', label: 'Every Month'},
        {value: 'yearly', label: 'Every Year'}
    ]

    untilOptions = [
        {value: 'month', label: '1 Month'},
        {value: 'months3', label: '3 Months'},
        {value: 'months6', label: '6 Months'},
        {value: 'year', label: '1 Year'},
        {value: 'indefinitely', label: 'Indefinitely'},
        {value: 'custom', label: 'Custom'}
    ]

    componentDidUpdate(prevProps) {
        const prevStartDate = moment(prevProps.startDate);
        const startDate = moment(this.props.startDate);

        if (prevStartDate.isSame(startDate) && startDate.hour() === 0 && moment().isSame(startDate, 'date')
            && !moment(this.state.rRuleObject.dtstart).isSame(startDate) && this.state.rRuleObject.dtstart === null) {
            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    dtstart: startDate.toDate()
                },
                untilDateKey: uuidv4()
            }, ()=> {
                if (!this.props.shouldKeepUntil)
                    this.setUntilDate(true)
            } );
        }

        if (!prevStartDate.isSame(startDate) && !moment(this.state.rRuleObject.dtstart).isSame(startDate)) {
            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    dtstart: this.props.timeChanged ? this.state.rRuleObject.dtstart : startDate.toDate() 
                },
                untilDateKey: uuidv4()
            }, ()=> {
                if (!this.props.shouldKeepUntil) {
                    this.setUntilDate(false)
                } else if (this.props.shouldKeepUntil && this.props.timeChanged) {
                    this.setUntilDate(false, true)
                }
            } );
        }

        if (this.props.recurrenceObject.hasOwnProperty('dtstart') && this.props.recurrenceObject.dtstart
                && this.props.isEditing && !this.state.rRuleObject.dtstart && this.state.frequency !== 'none') {
            this.initializeRRule();
            return;
        }

        if (prevStartDate.isSame(startDate) && this.state.rRuleObject.dtstart === null) {
            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    dtstart: startDate.toDate()
                },
                untilDateKey: uuidv4()
            }, ()=> {
                if (!this.props.shouldKeepUntil)
                    this.setUntilDate(true)
            } );
        }

        

        if (prevProps.disabled !== this.props.disabled) {
            this.setState({
                untilDateKey: uuidv4()
            })
        }
    }

    initializeUntilOptions = (recurrence) => {
        switch (recurrence) {
            case 'monthly':
                return [this.untilOptions[1], this.untilOptions[2], this.untilOptions[3], this.untilOptions[4], this.untilOptions[5]];
            case 'yearly':
                return [this.untilOptions[4], this.untilOptions[5]];
            default :
                return this.untilOptions
        }
    }

    initializeRRule = () => {
        const { recurrenceObject, rUntilDate } = this.props;
        let { freq, interval, until } = recurrenceObject;
        let untilDefaultValue = {}, valueUntilDate = {};
        let recurrenceDefaultValue, frequency;
        switch (freq) {
            case Frequency.DAILY:
                frequency = this.options[1].value;
                recurrenceDefaultValue = this.options[1];
                break;
            case Frequency.WEEKLY:
                frequency = interval === 2 ? this.options[3].value : this.options[2].value;
                recurrenceDefaultValue = interval === 2 ? this.options[3] : this.options[2];
                break;
            case Frequency.MONTHLY:
                frequency = this.options[4].value;
                recurrenceDefaultValue = this.options[4];
                break;
            case Frequency.YEARLY:
                frequency = this.options[5].value;
                recurrenceDefaultValue = this.options[5];
                break;
            default:
                break;
        }

        switch (rUntilDate) {
            case 'month':
                untilDefaultValue = this.untilOptions[0]
                valueUntilDate = this.untilOptions[5]
                break
            case 'months3':
                untilDefaultValue = this.untilOptions[1]
                valueUntilDate = this.untilOptions[5]
                break
            case 'months6':
                untilDefaultValue = this.untilOptions[2]
                valueUntilDate = this.untilOptions[5]
                break
            case 'year':
                untilDefaultValue = this.untilOptions[3]
                valueUntilDate = this.untilOptions[5]
                break
            case 'indefinitely':
                untilDefaultValue = this.untilOptions[4]
                valueUntilDate = this.untilOptions[5]
                break
            case 'custom':
                untilDefaultValue = this.untilOptions[5]
                valueUntilDate = this.untilOptions[5]
                break
            default:
                untilDefaultValue = this.untilOptions[0]
                valueUntilDate = this.untilOptions[0]
                break
        }
        this.setState({
            rRuleObject: { wkst: 0, ...recurrenceObject},
            untilDefaultValue,
            recurrenceDefaultValue,
            valueUntilDate,
            frequency,
            rUntilDate,
            hideUntil: false,
            hideCustom: rUntilDate !== 'custom',
            untilDate: moment(until).toISOString(),
            dropdownKey: uuidv4()
        // }, () => this.setUntilDate(true));
        })
    }

    onChangeUntilOption = (value) => {
        this.setState({
            untilOption: value.value,
            hideCustom: value.value !== 'custom',
            valueUntilDate: value
        }, () => this.setUntilOption())
    }

    setUntilOption = (isInitializing = false) => {
        const { frequency,  untilOption} = this.state;
        if (!isInitializing  && frequency !== 'none') {
            let untilDate = moment(this.props.startDate).clone();
            switch (untilOption) {
                case 'indefinitely':
                    untilDate = untilDate.add(15, 'year');
                    break
                case 'year':
                    untilDate = untilDate.add(1, 'year');
                    break
                case 'months6':
                    untilDate = untilDate.add(6, 'month');
                    break
                case 'months3':
                    untilDate = untilDate.add(3, 'month');
                    break
                case 'month':
                    untilDate = untilDate.add(1, 'month');
                    break
                case 'custom':
                    switch (frequency) {
                        case 'daily':
                            untilDate = untilDate.add(1, 'days');
                            break;
                        case 'weekly':
                            untilDate = untilDate.add(1, 'weeks');
                            break;
                        case 'weekly2':
                            untilDate = untilDate.add(2, 'weeks');
                            break;
                        case 'monthly':
                            untilDate = untilDate.add(1, 'month');
                            break;
                        case 'yearly':
                            untilDate = untilDate.add(1, 'year');
                            break;
                        default:
                            return;
                    }
                    break
                default:
                    break
            }

            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    until: untilDate.toDate(),
                },
                rUntilDate: untilOption,
                untilDate: untilDate.toISOString(),
                minUntilDate: untilDate.toISOString(),
                untilOptions: this.initializeUntilOptions(frequency),
                untilDateKey: uuidv4()
            }, () => this.onChangeRRule(true))
        }
    }

    setUntilDate = (isInitializing = false, onlyTimeChanged = false, isChange = false) => {
        const { frequency } = this.state;
        let rUntilDate;

        if (frequency === 'none') {
            this.setState({
                hideCustom: true,
                rRuleObject: {}
            },() => this.onChangeRRule())
        }

        if (onlyTimeChanged) {
            const eventStart = moment(this.props.startDate);
            let ruleStart = moment(this.state.rRuleObject.dtstart);
            let untilDate = moment(this.state.rRuleObject.until).clone();
            ruleStart.set({hours: eventStart.hours(), minutes: eventStart.minutes()});
            untilDate.set({hours: eventStart.hours(), minutes: eventStart.minutes()});

            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    dtstart: ruleStart.toDate(),
                    until: untilDate.toDate()
                }
            }, () => this.onChangeRRule(false))
            return;
        }

        if (!isInitializing && frequency !== 'custom' && frequency !== 'none' && isChange) {
            let untilDate = moment(this.props.startDate).clone();
            let freq = 0, interval = 1; 
            untilDate = untilDate.add(1, 'month');
            rUntilDate = 'month';
            switch (frequency) {
                case 'daily':
                    freq = Frequency.DAILY;
                    break;
                case 'weekly':
                    freq = Frequency.WEEKLY
                    break;
                case 'weekly2':
                    freq = Frequency.WEEKLY
                    interval = 2
                    break;
                case 'monthly':
                    freq = Frequency.MONTHLY;
                    untilDate = untilDate.add(3, 'month');
                    rUntilDate = 'months3';
                    break;
                case 'yearly':
                    freq = Frequency.YEARLY;
                    untilDate = untilDate.add(15, 'year');
                    rUntilDate = 'indefinitely';
                    break;
                default:
                    break;
            }

            let dtstart = this.state.rRuleObject.dtstart;

            if (!dtstart && this.props.originalRecurrenceObject.dtstart) {
                dtstart = moment(this.props.originalRecurrenceObject.dtstart).toDate();
            }
            
            this.setState({
                rRuleObject: {
                    ...this.state.rRuleObject,
                    dtstart,
                    freq,
                    until: untilDate.toDate(),
                    interval
                },
                valueUntilDate: this.initializeUntilOptions(frequency)[0],
                untilDate: untilDate.toISOString(),
                hideCustom: true,
                minUntilDate: untilDate.toISOString(),
                untilOptions: this.initializeUntilOptions(frequency),
                untilDateKey: uuidv4(),
                untilDefaultValue: this.initializeUntilOptions(frequency)[0],
                rUntilDate,
            }, () => this.onChangeRRule(true))

        } else if (isInitializing) {
            const untilDate = moment(this.state.untilDate);
            this.setState({
                untilDate: untilDate.toISOString(),
                minUntilDate: untilDate.toISOString(),
                rRuleObject: {
                    ...this.state.rRuleObject,
                    until: untilDate.toDate()
                },
                untilDateKey: uuidv4()
            })
        }
    }

    onChangeFrequency = (event) => {
        const { value } = event;

        this.setState({
            frequency: value,
            showCustom: value === 'custom',
            hideUntil: value === 'custom' || value === 'none'
        }, () => this.setUntilDate(false, false, true))
    }

    onChangeRRule = (frequencyOrIntervalChanged = false) => {
        this.props.onChangeRRule(this.state.rRuleObject, frequencyOrIntervalChanged, this.state.rUntilDate);
    }

    onchangeUntilDate = (dateString) => {
        const eventStart = moment(this.props.startDate);
        const untilDate = moment(dateString).clone().set({hours: eventStart.get('hours'), minutes: eventStart.get('minutes')});

        this.setState({
            rRuleObject: {
                ...this.state.rRuleObject,
                until: untilDate.toDate()
            }
        }, () => this.onChangeRRule(true))
    }

    render() {
        const { untilDate, minUntilDate } = this.state;
        return (
            <Row start="xs">
                <Col xs={12}>
                    <Row>
                        <Col xs={4}>
                            <Dropdown
                                dropdownKey={this.state.dropdownKey}
                                label="Recurrence"
                                options={this.options}
                                onChange={this.onChangeFrequency}
                                defaultValue={this.state.recurrenceDefaultValue}
                                disabled={this.props.disabled}
                                />
                        </Col>
                        <Col xs={4}>
                            {!this.state.hideUntil &&
                                <Dropdown
                                    dropdownKey={this.state.dropdownKey}
                                    label="Type"
                                    options={this.state.untilOptions}
                                    onChange={this.onChangeUntilOption}
                                    defaultValue={this.state.untilDefaultValue}
                                    disabled={this.props.disabled}
                                    value={this.state.valueUntilDate}
                                    />
                            }
                        </Col>
                        <Col xs={4}>
                            {!this.state.hideCustom &&
                                <>
                                    <Datepicker 
                                        datePickerKey={this.state.untilDateKey}
                                        label="Until Date"
                                        minDate={minUntilDate}
                                        value={untilDate}
                                        enableTime={false}
                                        altFormat="F j, Y"
                                        onChange={this.onchangeUntilDate}
                                        disabled={this.props.disabled}
                                    />
                                </>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}

RRuleInput.propTypes = {
    rule: PropTypes.string
}

export default RRuleInput
